import { render, staticRenderFns } from "./home-trend-up.vue?vue&type=template&id=1e2273d1&"
import script from "./home-trend-up.vue?vue&type=script&lang=js&"
export * from "./home-trend-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports